export default {
  application: {
    title: "Sushi & Noodles",
    description: ""
  },

  locales: {
    default: 'it',
    available: ['de', 'en', 'it'],
  },

  hourTable: [
    { label: 'monday', q1: ['9:00', ''], q2: ['', '22:00'] },
    { label: 'tuesday', q1: ['9:00', ''], q2: ['', '22:00'] },
    { label: 'wednesday', q1: ['9:00', ''], q2: ['', '22:00'] },
    { label: 'thursday', q1: ['9:00', ''], q2: ['', '22:00'] },
    { label: 'friday', q1: ['9:00', ''], q2: ['', '22:00'] },
    { label: 'saturday', q1: ['9:00', ''], q2: ['', '22:00'] },
    { label: 'sunday', q1: ['9:00', ''], q2: ['', '22:00'] },
  ],

  map: {
    markers: [],
    options: {
      center: [47.14, 10.5],
      zoom: 14
    }
  },

  links: {
    facebook: '',
    instagram: '',
  },
}
